// <head> metadata for PrivacyPage (https://www.dbos.dev/privacy).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Privacy Policy | DBOS',
    },
    {
      property: 'og:title',
      content: 'Privacy Policy | DBOS',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Privacy Policy | DBOS',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/privacy',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
